import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.pageTitle',
    defaultMessage: 'Questionari AML e FATCA-CRS',
  },
  cardTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.cardTitle',
    defaultMessage: 'Questionario AML',
  },
  titolareSectionTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.titolareSectionTitle',
    defaultMessage: 'Il soggetto dichiara di essere un titolare effettivo',
  },
  attivitaSectionTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.attivitaSectionTitle',
    defaultMessage:
      'Principale insediamento attività (altro lavoratore in proprio)',
  },
  pepSectionTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.pepSectionTitle',
    defaultMessage:
      'Il cliente è un soggetto PEP (Politically Exposed Person) o ha rapporti con PEP?',
  },
  attivitaFinanziariaSectionTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.attivitaFinanziariaSectionTitle',
    defaultMessage: 'Valutazione della situazione finanziaria',
  },
  fatcaTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.fatcaTitle',
    defaultMessage: 'Questionario FATCA e CRS',
  },
  fatcaQuestion: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.fatcaQuestion',
    defaultMessage:
      'Dichiarazione di residenza fiscale negli Stati Uniti (Specified US Person ai sensi della normativa FATCA)*',
  },
  crsQuestion: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.crsQuestion',
    defaultMessage:
      'Dichiarazione di residenza fiscale in Paesi diversi dall\'Italia e dagli Stati Uniti ai sensi della normativa CRS',
  },
  fatcaResponse1: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.fatcaResponse1',
    defaultMessage: 'Fiscalmente residente negli USA',
  },
  fatcaResponse2: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.fatcaResponse2',
    defaultMessage: 'Fiscalmente non residente negli USA',
  },
  tin: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.tin',
    defaultMessage: 'TIN*',
  },
  crsQuestionDescription: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.crsQuestionDescription',
    defaultMessage:
      'Per gli Stati che non rilasciano il codice fiscale è necessario continuare con la sottoscrizione cartacea.',
  },
  residenzaFiscaleTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.residenzaFiscaleTitle',
    defaultMessage: 'Residenza fiscale',
  },
  codiceFiscaleTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.codiceFiscaleTitle',
    defaultMessage: 'Codice fiscale *',
  },
  residenzaFiscalePlaceholder: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.residenzaFiscalePlaceholder',
    defaultMessage: 'Stato di residenza fiscale',
  },
  nazioneAttivitaTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.nazioneAttivitaTitle',
    defaultMessage: 'Nazione',
  },
  provinciaAttivitaTitle: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.provinciaAttivitaTitle',
    defaultMessage: 'Provincia',
  },
  provinciaAttivitaPlaceholder: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.provinciaAttivitaPlaceholder',
    defaultMessage: 'Provincia attività*',
  },
  codiceFiscalePlaceholder: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.codiceFiscalePlaceholder',
    defaultMessage: 'Inserisci il codice fiscale',
  },
  insertOther: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.insertOther',
    defaultMessage: 'Inserisci altra residenza fiscale',
  },
  remove: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.remove',
    defaultMessage: 'Rimuovi residenza fiscale',
  },
  save: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.save',
    defaultMessage: 'Salva',
  },
  positionStartDate: {
    id: 'homeOnboardingSelfAmlFatcaCrsSurvey.positionStartDate',
    defaultMessage: 'Data inizio carica*',
  },
  finishedAmlTitle: {
    id: 'homeOnboardingSelfAmlSurvey.toastSuccessAmlTitle',
    defaultMessage: 'Questionario AML completato',
  },
  finishedAmlDesc: {
    id: 'homeOnboardingSelfAmlSurvey.toastSuccessAml',
    defaultMessage:
      'Gentile {customerName},\nla compilazione dei questionari AML è avvenuta con successo.',
  },
  questionErrorMessage: {
    id: 'homeOnboardingSelfAmlSurvey.questionErrorMessage',
    defaultMessage: 'La risposta fornita alla domanda "{first}" risulta incoerente con quella fornita alla domanda {others}.'
  }
});
